import isEmpty from 'lodash/isEmpty';

import {
  getDictionaryByNameSelector,
  IBusinessUnitModel,
  IStoreWithDictionary,
} from '@crm-package/dictionaries';

import {
  PROMO_TYPE,
  TRANSACTION_SUB_TYPE_CREDIT_DICTIONARY_NAME,
} from './consts';
import {
  ICheckPromoBusinessUnitsByPromoEditRight,
  IDictionaryItem,
  IGetBUByRights,
  IMyAccountUrl,
  locations,
} from './types';

export const getErrorsArray = (
  errors: { [key: string]: any },
  res: string[] = []
) => {
  Object.entries(errors).forEach(([, error]: [string, any]) => {
    if (error) {
      if (typeof error === 'object') {
        getErrorsArray(error, res);
      } else {
        res.push(error);
      }
    }
  });

  return res;
};

export const getDefaultPromoFormData = (state: IStoreWithDictionary) => {
  const languages = getDictionaryByNameSelector(state, 'language');
  const subTypes = getDictionaryByNameSelector(
    state,
    TRANSACTION_SUB_TYPE_CREDIT_DICTIONARY_NAME
  );

  return {
    type: PROMO_TYPE.DEPOSIT_BONUS,
    visible: true,
    rule: {
      bonusConditions: [{}],
    },
    businessUnits: [],
    texts: languages.map(({ id }) => ({ languageId: id })),
    transactionSubType: subTypes[0].id,
    totalDepositFrom: null,
    totalDepositTo: undefined,
    depositCountFrom: undefined,
    depositCountTo: undefined,
    totalBonusAmount: undefined,
    maxUsage: undefined,
  };
};

export const getMyAccountUrlByEnvironmentId = (
  myAccountUrls: ReadonlyArray<IMyAccountUrl>,
  environmentId: number
) => myAccountUrls.find((item) => item.environmentId === environmentId)?.value;

export const disabledAll = (item: any) => ({ ...item, disabled: true });

export const getBUByRights = ({
  userBURight,
  rights,
  businessUnitRights,
  businessUnits,
}: IGetBUByRights): IBusinessUnitModel[] => {
  const businessUnitsByUserBURight = businessUnitRights[userBURight];

  if (rights.includes('All')) return businessUnits;

  if (isEmpty(businessUnitsByUserBURight)) return businessUnits;

  if (!isEmpty(businessUnitsByUserBURight)) {
    return businessUnits.filter((businessUnit) =>
      businessUnitsByUserBURight?.includes(businessUnit.id)
    );
  }

  return [];
};

export const checkPromoBusinessUnitsByPromoEditRight = ({
  promoBusinessUnits,
  rights,
  businessUnitRights,
  businessUnits,
}: ICheckPromoBusinessUnitsByPromoEditRight): boolean => {
  const editableBUIds = getBUByRights({
    userBURight: 'promo Edit',
    rights,
    businessUnitRights,
    businessUnits,
  }).map(({ id }) => id);

  return promoBusinessUnits.some((businessUnitId) =>
    editableBUIds.includes(businessUnitId)
  );
};

export const isNewPromo = (id: string) => id === 'new';

export const stringToDictionaryItem = (str: string): IDictionaryItem => ({
  id: str,
  name: str,
});

export const isLeadPromo = (location: locations) =>
  location === locations.LOCATION_LEAD_DASHBOARD;
